var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileOptIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 32.5C21 33.3297 20.3297 34 19.5 34C18.6703 34 18 33.3297 18 32.5C18 31.6703 18.6703 31 19.5 31C20.3297 31 21 31.6703 21 32.5ZM27 15.25V34.75C27 35.9922 25.9922 37 24.75 37H14.25C13.0078 37 12 35.9922 12 34.75V15.25C12 14.0078 13.0078 13 14.25 13H24.75C25.9922 13 27 14.0078 27 15.25ZM25.5 15.25C25.5 14.8375 25.1625 14.5 24.75 14.5H14.25C13.8375 14.5 13.5 14.8375 13.5 15.25V34.75C13.5 35.1625 13.8375 35.5 14.25 35.5H24.75C25.1625 35.5 25.5 35.1625 25.5 34.75V15.25Z",
    fill: "#FF8B4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3824 16.0555L34.4592 13.1322C34.3218 12.9949 34.0992 12.9949 33.9619 13.1322L31.0387 16.0555C30.9013 16.1928 30.9013 16.4154 31.0387 16.5528L31.2873 16.8014C31.4246 16.9387 31.6473 16.9387 31.7846 16.8014L33.6842 14.9018V26.9474H30.7025C30.6094 26.9474 30.5202 26.9843 30.4544 27.0501L30.1035 27.401C29.8824 27.622 30.039 28 30.3516 28H34.0351C34.4227 28 34.7368 27.6858 34.7368 27.2982V14.9018L36.6365 16.8014C36.7738 16.9387 36.9964 16.9387 37.1337 16.8014L37.3824 16.5528C37.5197 16.4154 37.5197 16.1928 37.3824 16.0555Z",
    fill: "#FF8B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileOptIn);
export default __webpack_public_path__ + "static/media/Mobile Opt-In.0b4aab2c8679327328ae4e7c66dea5b6.svg";
export { ForwardRef as ReactComponent };